import { resetStateAction } from "common/redux/resetStateAction";
import { useLogoutMutation } from "features/auth/authAPI";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

function Logout() {
  const [logout] = useLogoutMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const result = await logout();
      if ("data" in result) {
        dispatch(resetStateAction());
        if (result.data?.ssoLogoutUrl?.startsWith("https://")) {
          window.location.href = result.data.ssoLogoutUrl;
        }
      }
    })();
  }, [logout, dispatch]);

  return null;
}

export default Logout;
